/* eslint-disable no-unused-vars */
import Choices from 'choices.js';

window.createSelects = function()
{
  const selectEls = document.querySelectorAll('.js-select');

  if (selectEls) {
    [...selectEls].forEach((element) => {
      const choices = new Choices(element, {
        placeholder: true,
        searchEnabled: false,
        shouldSort: false,
        classNames: {
          highlightedState: 'k-is-highlighted',
          placeholder: 'k-choices__placeholder',
        },
      });
    });
  }
}

window.createSelects();